import axios from 'axios'
import { message } from 'antd'
import { API_BASE_URL } from '../config'
import store from '../store'
import storage from '../utils/storage'

const headers = {}
const http = axios.create({
  baseURL: API_BASE_URL,
  headers,
})

http.interceptors.request.use(
  (config: any) => {
    const token = storage.get('token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (err: any) => {
    return Promise.reject(err)
  }
)

http.interceptors.response.use(
  (res: any) => {
    return res.data
  },
  (err) => {
    if (err.response?.status >= 400) {
      message.error(err.response.data?.msg)
      if (err.response?.status === 401) {
        // 去登录页
        store.dispatch.user.logout()
      }
    }
    return Promise.reject(err.response)
  }
)

export default http
